import script from "./ChooseTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseTask.vue?vue&type=script&setup=true&lang=js"

import "./ChooseTask.vue?vue&type=style&index=0&id=152ddb45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-152ddb45"]])

export default __exports__